import React from 'react';
import styled from 'styled-components';

// import { Mainbar } from '../../components/Mainbar/Mainbar';
import { Navbar } from '../../components/Navbar/Navbar';
import { Sidebar } from '../../components/Sidebar/Sidebar';

import { ApartmentContractInfo } from '../../components/CM10-010-apartment-contract-info/ApartmentContractInfo/ApartmentContractInfo';

import RouterTrackerForAnalytics from '../../lib/utils/RouterTrackerForAnalytics'; // [MEMO] 구글 애널리틱스 라우터 트래커

const ApartmentContractInfoPage = () => {
  const $title = document.head.querySelector('title');
  $title!.innerText = '계약 정보 조회';
  RouterTrackerForAnalytics();

  return (
    <>
      {/* <Mainbar /> */}
      {/* 👇 1. 네브바 */}
      {/* <Navbar /> */}
      {/* 👆 1. 네브바 */}

      {/* <Body> */}
      {/* 👇 2. 사이드바 */}
      {/* <Sidebar /> */}
      {/* 👆 2. 사이드바 */}
      {/* <Contents> */}
      {/* <Wrap> */}
      {/* 👇 3. 페이지 */}
      <ApartmentContractInfo />
      {/* 👆 3. 페이지 */}
      {/* </Wrap>
        </Contents>
      </Body> */}
    </>
  );
};

export default ApartmentContractInfoPage;

const Body = styled.div`
  display: flex;
  margin-top: 55px; /* 네브바의 height 감안 */
`;

const Contents = styled.div`
  margin-left: 200px; /* 사이드바의 width 감안 */
  width: 100vw;
  height: calc(100vh - 55px); /* 네브바의 height 감안 */
  /* background-color: orange; */
  background-color: ${({ theme }) => theme.backgroundColor.gray};
`;

const Wrap = styled.div`
  padding: 15px;
  /* background-color: pink; */
  background-color: ${({ theme }) => theme.backgroundColor.gray};
`;
